import { render, staticRenderFns } from "./RenderDetector.vue?vue&type=template&id=4821d956&"
import script from "./RenderDetector.vue?vue&type=script&lang=js&"
export * from "./RenderDetector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports